import template from "./accountNumber.html";
import controller from "./accountNumber.controller";

export default {
	restrict: "E",
	bindings: {
		account: "=",
		types: "<",
		form: "=",
		labelKey: "<",
		helpItem: "<",
		readOnly: "<",
		apiValidationError: "<",
	},
	template,
	controller,
	controllerAs: "vm",
};



// WEBPACK FOOTER //
// ./src/app/common/ui/account-number/accountNumber.component.js